import React, { Component } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import moment from 'moment';
import toastr from 'toastr';

export default class CallbackCommentPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'history', // 'history' | 'add'
            contact_name: '',
            contact_role: '',
            contact_phone: '',
            comment: '',
            analyte_name: '',
            errors: []
        };
    }

    resetForm = () => {
        this.setState({
            contact_name: '',
            contact_role: '',
            contact_phone: '',
            comment: '',
            analyte_name: '',
            errors: []
        });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    validate = () => {
        const errors = [];
        if (!this.state.contact_name.trim()) errors.push('contact_name');
        if (!this.state.comment.trim()) errors.push('comment');
        this.setState({ errors });
        return errors.length === 0;
    };

    hasError = (field) => this.state.errors.includes(field);

    handleSubmit = () => {
        if (!this.validate()) {
            toastr.error('Please fill in all required fields');
            return;
        }
        const entry = {
            contact_name: this.state.contact_name.trim(),
            contact_role: this.state.contact_role.trim(),
            contact_phone: this.state.contact_phone.trim(),
            comment: this.state.comment.trim(),
            analyte_name: this.state.analyte_name.trim()
        };
        if (this.props.onSubmit) {
            this.props.onSubmit(entry);
        }
        this.resetForm();
        this.setState({ mode: 'history' });
    };

    handleClose = () => {
        this.resetForm();
        this.setState({ mode: 'history' });
        if (this.props.onClose) this.props.onClose();
    };

    renderHistory() {
        const history = this.props.callbackComments || [];
        return (
            <>
                <Modal.Body>
                    {history.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            <i className="fas fa-phone-slash fa-3x mb-3 d-block"></i>
                            <p>No critical value callbacks have been logged for this order.</p>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Date / Time</th>
                                        <th>Called By</th>
                                        <th>Contact</th>
                                        <th>Role</th>
                                        <th>Phone</th>
                                        <th>Analyte</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((entry, idx) => (
                                        <tr key={idx}>
                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                {entry.called_at
                                                    ? moment(entry.called_at).format('MM/DD/YYYY HH:mm')
                                                    : '—'}
                                            </td>
                                            <td>{entry.called_by || '—'}</td>
                                            <td>{entry.contact_name || '—'}</td>
                                            <td>{entry.contact_role || '—'}</td>
                                            <td>{entry.contact_phone || '—'}</td>
                                            <td>{entry.analyte_name || '—'}</td>
                                            <td>{entry.comment || '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose}>Close</Button>
                    <Button variant="primary" onClick={() => this.setState({ mode: 'add' })}>
                        <i className="fas fa-plus mr-1"></i> Log Callback
                    </Button>
                </Modal.Footer>
            </>
        );
    }

    renderAddForm() {
        return (
            <>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Contact Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="contact_name"
                                value={this.state.contact_name}
                                onChange={this.handleChange}
                                placeholder="Name of person contacted"
                                isInvalid={this.hasError('contact_name')}
                            />
                            <Form.Control.Feedback type="invalid">
                                Contact name is required
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className="row">
                            <div className="col-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Contact Role / Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="contact_role"
                                        value={this.state.contact_role}
                                        onChange={this.handleChange}
                                        placeholder="e.g. Nurse, Physician"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Contact Phone</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="contact_phone"
                                        value={this.state.contact_phone}
                                        onChange={this.handleChange}
                                        placeholder="Phone number"
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label>Analyte / Test (optional)</Form.Label>
                            <Form.Control
                                type="text"
                                name="analyte_name"
                                value={this.state.analyte_name}
                                onChange={this.handleChange}
                                placeholder="e.g. Fentanyl, Oxycodone"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>
                                Callback Notes <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleChange}
                                placeholder="Describe what was communicated, read-back confirmation, action taken..."
                                isInvalid={this.hasError('comment')}
                            />
                            <Form.Control.Feedback type="invalid">
                                Callback notes are required
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className="text-muted small">
                            <i className="fas fa-info-circle mr-1"></i>
                            Your name and the current timestamp will be recorded automatically.
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { this.resetForm(); this.setState({ mode: 'history' }); }}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={this.handleSubmit}>
                        <i className="fas fa-phone mr-1"></i> Save Callback Log
                    </Button>
                </Modal.Footer>
            </>
        );
    }

    render() {
        const callbackCount = (this.props.callbackComments || []).length;
        return (
            <Modal
                show={this.props.show}
                onHide={this.handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-phone-alt mr-2 text-danger"></i>
                        Critical Value Callbacks
                        {callbackCount > 0 && (
                            <span className="badge badge-danger ml-2">{callbackCount}</span>
                        )}
                    </Modal.Title>
                </Modal.Header>
                {this.state.mode === 'history' ? this.renderHistory() : this.renderAddForm()}
            </Modal>
        );
    }
}
